export default "__VITE_ASSET__0_j966li__"